<template>
  <div class="coupon-mask" :class="`${createRenderType}-coupon-mask`">
    <div class="coupon">
      <div class="title">{{ $$t("credit.limied_time") }}</div>
      <div class="discount">
        <span class="discount-num">{{ discountData?.discount_percent ?? "" }}%</span>
        <span class="discount-unit">{{ $$t("credit.off") }}</span>
      </div>
      <div class="count-down">
        <div class="clock"></div>
        <div class="text">{{ $$t("credit.expires_in") }}</div>
        <div class="time">{{ formatCountdown(userDataStore.countdown) }}</div>
      </div>
      <div class="content">
        <div class="item" v-for="(item, index) in getContent()" :key="index"><i></i>{{ item.text }}</div>
      </div>
      <div class="btns">
        <div class="btn-black pointer" @click="goToPay">
          <div class="text">{{ $t("credit.claim_20_off_continue", { count: discountData?.discount_percent }) }}</div>
        </div>
        <div class="btn-nomal pointer" @click="closeDialog">
          {{ $t("credit.leave_anyway") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, reactive } from "vue";
import { $$t, $$language } from "@/i18n/i18n.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import { useRouter, useRoute } from "vue-router";
import useUserDataStore from "@/store/userDataStore";

const Router = useRouter();
const route = useRoute();
const userDataStore = useUserDataStore();

const props = defineProps({
  discountData: {
    type: Object,
    default: () => ({}),
  },
  couponLocal: {
    type: Object,
    default: () => ({}),
  },
  productList: {
    type: Array,
    default: () => [],
  },
});

const emits = defineEmits(["update:visible"]);

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const discount = ref(20);
const getContent = () => {
  const yearProProduct = props.productList.find(
    (item) => item.period_name == props.couponLocal?.selectPeriod && item.level_name == props.couponLocal?.selectPlan
  );
  const rawPrice = Number(yearProProduct?.price) || 0;
  const discountRate = Number(discount?.value) || 0;
  const finalPrice = Math.round((rawPrice * (100 - discountRate)) / 100);
  const finalPriceWithDecimals = Number(((rawPrice * discountRate) / 100).toFixed(2));
  const discountMonth = Math.round((discountRate / 100) * 12);
  let info = [
    {
      text: $$t("credit.save_up_to", "", { count: `$ ${finalPrice}`,origin: `$ ${rawPrice}` }),
    },
    {
      text: $$t("credit.Works_with"),
    },
  ];
  
  // if (props.couponLocal.selectPeriod == "year") {
  //   info.push({
  //     text: $$t("credit.get_nearly", "", { count: discountMonth }),
  //   });
  // }
  return info;
};

const closeDialog = async () => {
  emits("update:visible", false);
};

watch(
  () => userDataStore.countdown,
  (newVal) => {
    if (newVal == 0) {
      closeDialog();
    }
  },
  { immediate: true }
);

const goToPay = () => {
  const { membership_source1, membership_source2, from_type } = route.query;
  Router.push({
    name: "payment",
    query: {
      membership_source1,
      membership_source2,
      from_type,
      level: props.couponLocal.selectPlan ?? "",
      period: props.couponLocal.selectPeriod ?? "",
    },
  });
  closeDialog();
};

const formatCountdown = (seconds) => {
  const totalMinutes = Math.floor(seconds / 60);
  const minutes = totalMinutes % 60;
  const secondsLeft = seconds % 60;

  // 格式化为 "mm min ss s"
  const formattedMinutes = `${minutes.toString().padStart(2, "0")}min`;
  const formattedSeconds = `${secondsLeft.toString().padStart(2, "0")}s`;

  // 如果分钟为0且秒数>0，则只显示秒（例如：05s）
  if (totalMinutes === 0) {
    return `${secondsLeft}s`;
  }

  return [formattedMinutes, formattedSeconds].join(" ");
};

onMounted(() => {
});
</script>

<style lang="scss" scoped>
.coupon-mask {
  position: fixed;
  z-index: 200;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  .coupon {
    background-image: url("@/assets/img/credit/bk-coupon.webp");
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 319px;
    height: 546px;
    transform: translate(-50%, -50%);
    .title {
      font-size: 24px;
      font-weight: 900;
      line-height: normal;
      text-align: center;
      color: #000000;
      padding-top: 32px;
      margin-bottom: 3px;
    }
    .discount {
      display: flex;
      align-items: end;
      justify-content: center;
      gap: 8px;
      margin-bottom: 10px;
      .discount-num {
        font-size: 80px;
        font-weight: bold;
        line-height: normal;
        color: #ff324d;
      }
      .discount-unit {
        font-size: 16px;
        font-weight: bold;
        line-height: 50px;
      }
    }
    .count-down {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-size: 18px;
      font-weight: bold;
      line-height: 24px;
      text-align: center;
      margin: 0 29px 11px;
      height: 56px;
      border-radius: 16px;
      background-color: #fff;
      .clock {
        width: 20px;
        height: 19px;
        background-image: url("@/assets/img/credit/clock.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }
      .text {
        color: #000000;
      }
      .time {
        color: #ff5f74;
      }
    }
    .content {
      padding: 16px;
      border-radius: 16px;
      background-color: #fff;
      margin: 0 29px 44px;
      .item {
        font-size: 16px;
        font-weight: 900;
        line-height: 1.4;
        margin-bottom: 14px;
        display: flex;
        align-items: flex-start;
        white-space: normal;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        i {
          flex-shrink: 0;
          width: 6px;
          height: 6px;
          margin-top: 7px;
          border-radius: 50%;
          background-color: #000000;
          margin-right: 8px;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .btns {
      width: 100%;
      position: absolute;
      bottom: 38px;
      .btn-black {
        margin: 0 29px 12px;
        background-color: #000000;
        border-radius: 71px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 64px;
        .text {
          background: linear-gradient(95deg, #a2ff7d 0%, #ffe95e 99%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
          font-size: 16px;
          font-weight: bold;
          line-height: normal;
          padding: 0 10px;
          text-align: center;
        }
      }
      .btn-nomal {
        margin: 0 29px;
        height: 36px;
        background: rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #000000;
        font-size: 12px;
        font-weight: 500;
        line-height: normal;
        border-radius: 39.94px;
      }
    }
  }
  &.mobile-coupon-mask {
    .coupon {
      width: 320px;
      margin: 0 auto;
    }
  }
}
</style>
